import i from "./index2.js";
import { resolveComponent as n, openBlock as t, createBlock as a, createCommentVNode as l } from "vue";
import p from "../../../../_virtual/index.js";
function d(o, e, m, g, f, c) {
  const s = n("expired-session-dialog");
  return o.loadDialog ? (t(), a(s, {
    key: 0,
    showDialog: o.showDialog,
    "onUpdate:showDialog": e[0] || (e[0] = (r) => o.showDialog = r)
  }, null, 8, ["showDialog"])) : l("", !0);
}
const w = /* @__PURE__ */ p(i, [["render", d]]);
export {
  w as default
};
//# sourceMappingURL=index.js.map
